<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: '',
	},
	width: {
		type: String,
		default: '16',
	},
	height: {
		type: String,
		default: '16',
	},
});

const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);

</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.33243 7.33333V5M8.33243 9.66667H8.3391M8.33243 13.3333C11.462 13.3333 13.9991 10.7963 13.9991 7.66667C13.9991 4.53705 11.462 2 8.33243 2C5.20282 2 2.66577 4.53705 2.66577 7.66667C2.66577 8.3 2.76966 8.90906 2.96135 9.47774C3.03348 9.69175 3.06955 9.79875 3.07605 9.88095C3.08247 9.96213 3.07762 10.019 3.05753 10.098C3.0372 10.1779 2.9923 10.261 2.90249 10.4272L1.81206 12.4456C1.65652 12.7335 1.57875 12.8774 1.59615 12.9885C1.61131 13.0853 1.66826 13.1705 1.75188 13.2215C1.84788 13.2801 2.01063 13.2632 2.33613 13.2296L5.75014 12.8767C5.85353 12.866 5.90522 12.8606 5.95234 12.8624C5.99868 12.8642 6.0314 12.8686 6.07659 12.879C6.12253 12.8896 6.18031 12.9118 6.29587 12.9564C6.9279 13.1999 7.61458 13.3333 8.33243 13.3333Z"
      :stroke="iconColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>